import { render, staticRenderFns } from "./WebsitesForm.vue?vue&type=template&id=2ef0cee8"
import script from "./WebsitesForm.vue?vue&type=script&lang=js"
export * from "./WebsitesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../website-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports